import React from 'react';

import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import PaymentContainer from 'containers/shopping-cart/payment-container';

const ShoppingCartPayment = () => {
  return (
    <div>
      <HeaderContainer />
      <PaymentContainer />
      <FooterContainer />
    </div>
  );
};

export default ShoppingCartPayment;
